import { pipe } from 'fp-ts/function'
import { decodeJson, get } from 'lib/request'

import { TVersion } from './common.codecs'

export const getCurrentAppVersion = async () => {
  return pipe(await get('api/health', {}), decodeJson(TVersion))
}
